import { InfoOutlined } from '@mui/icons-material'

import { useSelector } from '@tabeeb/store'
import { usePopoverState } from '@collaborate-health/uikit'
import { getIsControlInfoEnabled } from '@tabeeb/modules/appConfigState/selectors'

import { FormControl } from '../../types'
import FormControlInfoWindow from '../FormControlInfoWindow'

import { InfoIconButton } from './FormControlInfoButton.styles'

export interface FormControlInfoButtonProps {
  control: FormControl
}

const FormControlInfoButton: React.FC<FormControlInfoButtonProps> = ({ control }) => {
  const enabled = useSelector(getIsControlInfoEnabled)

  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  if (!enabled || !control.Info) {
    return null
  }

  return (
    <>
      <InfoIconButton
        ref={anchorRef}
        size='small'
        title='Question info'
        color='info'
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()

          onOpen()
        }}
      >
        <InfoOutlined fontSize='inherit' />
      </InfoIconButton>
      <FormControlInfoWindow open={open} anchorEl={anchorRef.current} control={control} onClose={onClose} />
    </>
  )
}

export default FormControlInfoButton

